
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noticias/articulistas",
      function () {
        return require("private-next-pages/noticias/articulistas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/noticias/articulistas"])
      });
    }
  